const links = {
  career: { index: 'https://career.ringleplus.com/' },
  teens: { index: 'https://www.ringleteens.com/' },
  speakingTest: { index: 'https://speakingtest.ringleplus.com/kr' },
  prep: { index: 'https://prep.ringleplus.com/' },
  aiTutor: {
    download: 'https://ringlestudent.onelink.me/A5Zb/idfo0xu1',
  },
  framer: {
    advPath: {
      '1on1': {
        index: '1on1',
        tutor: '1on1/tutor',
        material: '1on1/material',
      },
      aiTutor: { index: 'aitutor', promotion: 'aitutor/newyear-promo' },
    },
  },
}

export default links
